/**
 * LoadingFallback Component
 *
 * Displayed while lazy-loaded route components are being fetched.
 * Provides a consistent loading experience across the app.
 */

interface LoadingFallbackProps {
  message?: string
}

export function LoadingFallback({ message = 'Loading...' }: LoadingFallbackProps) {
  return (
    <div className="min-h-screen bg-gradient-to-b from-neutral-900 via-neutral-800 to-neutral-900 flex items-center justify-center">
      <div className="text-center">
        {/* Animated spinner */}
        <div className="relative w-16 h-16 mx-auto mb-4">
          <div className="absolute inset-0 border-4 border-amber-500/20 rounded-full" />
          <div className="absolute inset-0 border-4 border-transparent border-t-amber-500 rounded-full animate-spin" />
        </div>

        {/* Loading message */}
        <p className="text-neutral-400 text-sm">{message}</p>
      </div>
    </div>
  )
}

export default LoadingFallback
